import { zodResolver } from '@hookform/resolvers/zod';
import cn from 'classnames';
import { PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { FormValues, formSchema } from '@features/users/adminPanel/components/Form/Form.types.ts';
import { FieldInvoicingEmail } from '@features/users/adminPanel/components/FormFields/FieldInvoicingEmail/FieldInvoicingEmail.tsx';
import { FormFields } from '@features/users/adminPanel/components/FormFields/FieldTypes.ts';
import { FieldVatNumber } from '@features/users/adminPanel/components/FormFields/FieldVatNumber/FieldVatNumber.tsx';

import styles from './Form.module.scss';

interface FormProps {
  submitCallback: (data: FormValues) => void;
  initialValues?: FormValues;
  className?: string;
}

const defaultInitialValues: FormValues = {
  [FormFields.INVOICING_EMAIL]: '',
  [FormFields.VAT_NUMBER]: '',
};

export function Form({ submitCallback, className, children, initialValues }: PropsWithChildren<FormProps>) {
  const defaultValues = initialValues ?? defaultInitialValues;
  const form = useForm<FormValues>({
    defaultValues,
    resolver: zodResolver(formSchema),
  });

  const submitForm = (data: FormValues) => {
    submitCallback(data);
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(submitForm)} className={className}>
        <div className={cn('grid', styles.formWrapper)}>
          <div className='row'>
            <div className='col-6'>
              <FieldInvoicingEmail />
            </div>
            <div className='col-6'>
              <FieldVatNumber />
            </div>
          </div>
          {children}
        </div>
      </form>
    </FormProvider>
  );
}
